class PromoBox extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.toggleButton = this.querySelector("[data-promo-toggle]");
    this.toggleText = this.querySelector("[data-promo-toggle-text]");
    this.content = this.querySelector("[data-promo-content]");
    this.isOpen = false;
    this.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick(event) {
    if (event.target.closest("a, [data-popup-target]")) return;
    if (!event.target.closest("[data-promo-header], [data-promo-toggle]")) return;
    if (!this.toggleButton || !this.content) return;
    this.setOpen(!this.isOpen);
  }
  setOpen(isOpen) {
    this.isOpen = isOpen;
    this.toggleAttribute("open", isOpen);
    this.toggleButton.setAttribute("aria-expanded", String(isOpen));
    if (this.toggleText) {
      this.toggleText.textContent = isOpen ? "Click To Close" : "See Promos";
    }
  }
}
if (!customElements.get("promo-box")) {
  customElements.define("promo-box", PromoBox);
}
